// extracted by mini-css-extract-plugin
module.exports = {"paginado":"Paginado_paginado__1Qn1M","number":"Paginado_number__d2PfM"};